var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31693 5.89758V11.5589H2.4141V5.89758H0.589111V19.3765H2.4141V13.2537H8.31693V19.3765H10.1419V5.89758H8.31693Z",
    fill: "rgba(var(--provider-icon-color))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3973 1.19117C12.3973 0.533753 12.8883 0 13.4937 0H23.1605C23.7663 0 24.2573 0.533753 24.2573 1.19117V8.93313C24.9859 10.0576 25.4108 11.4005 25.4108 12.8445C25.4108 16.7966 22.2387 20 18.3271 20C14.4154 20 11.2438 16.7966 11.2438 12.8445C11.2438 11.4005 11.6687 10.0572 12.3973 8.93271V1.19117ZM21.8904 13.2813H18.4853V12.0638H23.2577V12.8942C23.2577 16.0359 20.6346 17.6827 18.3044 17.6827C15.5412 17.6827 13.1971 15.4682 13.1971 12.6728C13.1971 9.87738 15.5416 7.66291 18.3044 7.66291C19.9371 7.66291 21.0389 8.11974 22.3368 9.40653L21.4579 10.3474C20.3835 9.4622 19.6716 8.88042 18.3044 8.88042C16.1411 8.88042 14.5644 10.6104 14.5644 12.6724C14.5644 14.7343 16.1416 16.4639 18.3044 16.4639C20.1597 16.4639 21.7928 15.2604 21.8904 13.2813Z",
    fill: "rgba(var(--provider-icon-color))"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHg);
export default __webpack_public_path__ + "static/media/hg.d78d6ad021455d774f9e66abb87b3fbf.svg";
export { ForwardRef as ReactComponent };